import { useQuery } from '@tanstack/react-query';
import { fetchCommunicationsSummary } from '../services/communicationsSummary';
import { COMMUNICATIONS_SUMMARY_KEY } from './queryKeys';

// Global counts, one fetch, shared by the Overview stat row and status cards.
export function useCommunicationsSummary() {
    const query = useQuery({
        queryKey: COMMUNICATIONS_SUMMARY_KEY,
        queryFn: fetchCommunicationsSummary,
        staleTime: 60_000
    });

    return {
        summary: query.data ?? null,
        isLoading: query.isLoading,
        isError: query.isError,
        refetch: query.refetch
    };
}
